import { render, staticRenderFns } from "./EducationalStageForm.vue?vue&type=template&id=5db260ea&"
import script from "./EducationalStageForm.vue?vue&type=script&lang=js&"
export * from "./EducationalStageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports